import React from 'react';
import logo from './logo.svg';
import externalImg1 from '../assets/images/external_img1.jpeg';
import externalImg2 from '../assets/images/external_img2.jpg';
import externalImg3 from '../assets/images/external_img3.jpg';
import '../assets/css/style.css';
import './Articles.css';
import { Link } from "react-router-dom";

function Articles() {
  return (
<div className="container_12">
    <div className="grid_12">
        <div className="grid_4-lg grid_4-xl grid_12-xs grid_12-sm grid_12-md alpha-xs alpha-sm alpha-md alpha-lg alpha-xl">
            <div className="box-3">
                <div className="gradient_1"><h2><Link to="starlight1">第一届星光杯</Link></h2></div>
                <div className="box-3_pad">

                    <div className="wrapper hline2">
                        <Link to="/indexVideoB"><img src="https://img.youtube.com/vi/Sn60WOYo_UA/default.jpg" alt="" className="no_resize img1" width="118" /></Link>
                        <div className="box">
                            <p className="txt1">
                                <Link to="/indexVideoB"><span className="color2 txt_date">2021年4月24日</span></Link><br />
                                <Link to="/indexVideoB">《气排球操》新西兰第一届星光杯气排球锦标赛闭幕式演出</Link><br />
                                <br />
                                <br />
                            </p>
                        </div>
                    </div>

                    <div className="wrapper hline2">
                        <Link to="/indexVideo"><img src="https://img.youtube.com/vi/zMjmi7OvnME/mqdefault.jpg" alt="" className="no_resize img1" width="118" /></Link>
                        <div className="box">
                            <p className="txt1">
                                <Link to="/indexVideo"><span className="color2 txt_date">2021年3月-4月</span></Link><br />
                                <Link to="/indexVideo">《精彩绽放》新西兰第一届星光杯锦标赛</Link><br />
                                <br />
                                <br />
                            </p>
                        </div>
                    </div>

                    <div className="wrapper hline2">
                        <a href="https://www.meipian.cn/3hg4geav?share_depth=2&s_uid=21488523&share_to=group_singlemessage&first_share_to=singlemessage&first_share_uid=41713200" target="_blank" rel="noopener noreferrer"><img src={externalImg1} alt="" className="no_resize img1 /"  width="118" /></a>
                        <div className="box">
                            <p className="txt1">
                                <a href="https://www.meipian.cn/3hg4geav?share_depth=2&s_uid=21488523&share_to=group_singlemessage&first_share_to=singlemessage&first_share_uid=41713200" target="_blank" rel="noopener noreferrer"><span className="color2 txt_date">2021年3月20日</span><br /></a>
                                <a href="https://www.meipian.cn/3hg4geav?share_depth=2&s_uid=21488523&share_to=group_singlemessage&first_share_to=singlemessage&first_share_uid=41713200" target="_blank" rel="noopener noreferrer">《女队赛况》新西兰第一届星光杯气排球锦标赛<br /></a>
                                <br />
                            </p>
                        </div>
                    </div>
                    <Link to="starlight1" className="link1">[view all]</Link>
                </div>
            </div>
        </div>

        <div className="grid_4-lg grid_4-xl">
            <div className="box-3">
                <div className="gradient_1"><h2><Link to="starlight2">第二届星光杯</Link></h2></div>
                <div className="box-3_pad">
                    <div className="wrapper hline2">
                        <Link to="/indexVideo2B"><img src="https://img.youtube.com/vi/NZKNm7IfY1E/mqdefault.jpg" alt="" className="no_resize img1" width="118" /></Link>
                        <div className="box">
                            <p className="txt1">
                                <Link to="/indexVideo2B"><span className="color3 txt_date">2022年11月11日</span></Link><br />
                                <Link to="/indexVideo2B">《快乐气排球》新西兰第二届星光杯气排球锦标赛开幕式演出</Link><br />
                                <br />
                                <br />
                            </p>
                        </div>
                    </div>
                    <div className="wrapper hline2">
                        <Link to="/indexVideo2"><img src="https://img.youtube.com/vi/RHpkh9jocnk/mqdefault.jpg" alt="" className="no_resize img1" width="118" /></Link>
                        <div className="box">
                            <p className="txt1">
                                <Link to="/indexVideo2"><span className="color3 txt_date">2022年11月11日</span></Link><br />
                                <Link to="/indexVideo2">新西兰第二届星光杯气排球锦标赛开幕式直播回放</Link><br />
                                <br />
                                <br />
                            </p>
                        </div>
                    </div>

                    <div className="wrapper hline2">
                        <a href="http://auckland.china-consulate.gov.cn/chn/xwdt/202211/t20221115_10975030.htm" target="_blank" rel="noopener noreferrer"><img src={externalImg2} alt="" className="no_resize img1" width="118" /></a>
                        <div className="box">
                            <p className="txt1">
                                <a href="http://auckland.china-consulate.gov.cn/chn/xwdt/202211/t20221115_10975030.htm" target="_blank" rel="noopener noreferrer"><span className="color3 txt_date">2022年11月11日</span></a><br />
                                <a href="http://auckland.china-consulate.gov.cn/chn/xwdt/202211/t20221115_10975030.htm" target="_blank" rel="noopener noreferrer">《王俊超副总领事出席第二届“星光杯”气排球赛开幕式》新西兰第二届星光杯气排球锦标赛</a><br />
                                <br />
                            </p>
                        </div>
                    </div>
                    <Link to="starlight2" className="link1">[view all]</Link>
                </div>
            </div>
        </div>

        <div className="grid_4-lg grid_4-xl omega-xs omega-sm omega-md omega-lg omega-xl">
            <div className="box-3">
                <div className="gradient_1"><h2><Link to="starlight3">第三届星光杯</Link></h2></div>

                <div className="box-3_pad">
                    <div className="wrapper hline2">
                        <Link to="/indexVideo3B"><img src="https://img.youtube.com/vi/6UrQhZlF9RY/mqdefault.jpg" alt="" className="no_resize img1" width="118" /></Link>
                        <div className="box">
                            <p className="txt1">
                                <Link to="/indexVideo3B"><span className="color4 txt_date">2024年7月27日</span></Link><br />
                                <Link to="/indexVideo3B">新西兰气排球协会总会《备战第三届星光杯》</Link><br />
                                <br />
                                <br />
                            </p>
                        </div>
                    </div>
                    <div className="wrapper hline2">
                        <Link to="/indexVideo3"><img src="https://img.youtube.com/vi/a5_4oaAgzuM/mqdefault.jpg" alt="" className="no_resize img1" width="118" /></Link>
                        <div className="box">
                            <p className="txt1">
                                <Link to="/indexVideo3"><span className="color4 txt_date">2024年6月30日</span></Link><br />
                                <Link to="/indexVideo3">新西兰第三届星光杯气排球邀请赛《新闻发布》</Link><br />
                                <br />
                                <br />
                            </p>
                        </div>
                    </div>

                    <div className="wrapper hline2">
                        <a href="https://newzealandnewspaper.co.nz/%e6%96%b0%e8%a5%bf%e5%85%b0%e6%b0%94%e6%8e%92%e7%90%83%e5%8d%8f%e4%bc%9a%e6%80%bb%e4%bc%9a%e4%b8%be%e8%a1%8c%e7%9a%84%e6%96%b0%e8%a5%bf%e5%85%b0%e5%8d%8f%e4%bc%9a%e6%9d%af%e5%85%ac%e5%bc%80%e8%b5%9b/" target="_blank" rel="noopener noreferrer"><img src={externalImg3} alt="" className="no_resize img1" width="118" /></a>
                        <div className="box">
                            <p className="txt1">
<a href="https://newzealandnewspaper.co.nz/%e6%96%b0%e8%a5%bf%e5%85%b0%e6%b0%94%e6%8e%92%e7%90%83%e5%8d%8f%e4%bc%9a%e6%80%bb%e4%bc%9a%e4%b8%be%e8%a1%8c%e7%9a%84%e6%96%b0%e8%a5%bf%e5%85%b0%e5%8d%8f%e4%bc%9a%e6%9d%af%e5%85%ac%e5%bc%80%e8%b5%9b/" target="_blank" rel="noopener noreferrer">
                                <span className="color4 txt_date">2023年12月5日</span><br /></a>
<a href="https://newzealandnewspaper.co.nz/%e6%96%b0%e8%a5%bf%e5%85%b0%e6%b0%94%e6%8e%92%e7%90%83%e5%8d%8f%e4%bc%9a%e6%80%bb%e4%bc%9a%e4%b8%be%e8%a1%8c%e7%9a%84%e6%96%b0%e8%a5%bf%e5%85%b0%e5%8d%8f%e4%bc%9a%e6%9d%af%e5%85%ac%e5%bc%80%e8%b5%9b/" target="_blank" rel="noopener noreferrer">新西兰气排球协会总会《成功举办的”新西兰协会杯公开赛”精彩闭幕》<br />
                                <br />
</a>
                            </p>
                        </div>
                    </div>
                    <Link to="starlight3" className="link1">[view all]</Link>
                </div>
            </div>

        </div>

    </div>
</div>

  );
}

export default Articles;
